import { makeStyles, Typography } from "@material-ui/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationDot } from "@fortawesome/free-solid-svg-icons"

import { ResponseOption, Selected } from "../../../../utils/safetyPlanUtils"
import useSafetyPlanOptionStyles from "./useSafetyPlanOptionStyles"
import { colors } from "../../../../utils/theme"

interface UserAddedOptionProps {
  options: ResponseOption[]
  selection: Selected[]
}

/**
 * Displays the values a user has already added to a safety plan option —
 * either free-text entries or place objects. Each value is rendered as a row
 * in the option container style. Place objects (i.e. `{ place: string }`) are
 * shown with a location-dot icon; plain strings are shown as-is.
 *
 * @param options   - The `ResponseOption` entries whose ids are used to look up saved values in `selection`.
 * @param selection - The current list of selected items from which saved values are extracted.
 */
export default function UserAddedOption({
  options,
  selection,
}: UserAddedOptionProps) {
  const el: Selected[] = []
  for (let option of options) {
    const found = selection.find((el: Selected) => el.id === option.id)
    if (found) el.push(found)
  }
  const values = el.length > 0 ? el[0].value : []

  const userAddedOptionStyles = useStyles()
  const sharedStyles = useSafetyPlanOptionStyles()
  const classes = { ...userAddedOptionStyles, ...sharedStyles }
  return (
    <>
      {values.map((item: any, index: number) => (
        <div className={classes.optionContainer} key={index.toString()}>
          <Typography className={classes.optionUserAddedTxt}>
            {typeof item === "object" ? item.place : item}
          </Typography>
          {typeof item === "object" && (
            <FontAwesomeIcon
              icon={faLocationDot}
              className={classes.plusColor}
            />
          )}
        </div>
      ))}
    </>
  )
}

const useStyles = makeStyles(() => ({
  optionUserAddedTxt: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "20px",
    color: colors.primary.midnight,
    flex: "1 0 0",
    textAlign: "center",
  },
}))
